import React, { useState, useEffect, useReducer } from "react";
import useAuth from "../../../hooks/useAuth";
import { Helmet } from "react-helmet";
import { Link, Redirect, useNavigate } from "react-router-dom";
import Typography from "@mui/material/Typography";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import LoadingScreen from "../../../components/LoadingScreen";
import ToastHot from "react-hot-toast";
import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
import Reducer from "../../../services/Reducer";
import PropTypes from "prop-types";
import { Box, Grid, Tab, Tabs } from "@mui/material";
import { GetEventListHandler } from "../../../actions/mainAction";
import moment from "moment";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ py: 3 }}>{children}</Box>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const initState = {
  searchTerm: "",
  listingData: [],
  totalItem: "",
  loading: false,
  validate: false,
};

export default function EventList() {
  const [value, setValue] = React.useState(0);
  const [page, setPage] = React.useState(1);
  const [limit] = React.useState(10);
  const navigator = useNavigate();
  const [state, dispatch] = useReducer(Reducer, initState);
  const [shortType, setSortType] = useState("");

  const handleChange = (event, newValue) => {
    setValue(newValue);
    setPage(1); // ✅ reset page when switching tabs
  };

  useEffect(() => {
    getFilterwithPaginationList();
  }, [page, state.searchTerm, value]);

  const getFilterwithPaginationList = async () => {
    dispatch({ type: "LOAD", payload: true });
    const response = await GetEventListHandler(
      page,
      limit,
      state.searchTerm,
      value == 1 ? "past" : ""
    );
    console.log("response", response.data);
    if (response && response.data) {
      // setIsError(true)
      if (response.status === 200) {
        dispatch({ type: "LOAD", payload: false });
        dispatch({
          type: "SETDATA",
          payload: { name: "listingData", value: response.data.data.rows },
        });
        dispatch({
          type: "SETDATA",
          payload: { name: "totalItem", value: response.data.data.totalCount },
        });
      } else {
        dispatch({ type: "LOAD", payload: false });
        dispatch({
          type: "SETDATA",
          payload: { name: "listingData", value: [] },
        });
        dispatch({ type: "SETDATA", payload: { name: "totalItem", value: 0 } });
      }
    } else {
      dispatch({ type: "LOAD", payload: false });
      ToastHot.error("Something went wrong");
      // toast.error("Something went wrong");
    }
  };

  // ✅ NEW: debounce (same style as your other page)
  const debounce = (func) => {
    let timer;
    return function (...args) {
      const context = this;
      if (timer) clearTimeout(timer);
      timer = setTimeout(() => {
        timer = null;
        func.apply(context, args);
      }, 500);
    };
  };

  // ✅ NEW: search handler -> store in state.searchTerm
  const handleChangeSearch = (e) => {
    const { value } = e.target;
    setPage(1);
    dispatch({
      type: "SETDATA",
      payload: { name: "searchTerm", value: value },
    });
  };

  // ✅ NEW: debounced version
  const optimizedVersion = React.useMemo(
    () => debounce(handleChangeSearch),
    []
  );

  return (
    <>
      <Helmet>
        <title>Event</title>
      </Helmet>

      <div className="listingPages allAccountsPage">
        <div className="listingPagesHead">
          <div className="left">
            <h3>Event</h3>
          </div>
          <div className="right">
            <div className="rightInner">
              <div className="searchGroup">
                <div>
                  <i className="material-icons">search</i>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search"
                    id="searchTerm"
                    name="searchTerm"
                    onChange={optimizedVersion}
                  />
                </div>
              </div>
              {/* <Link to="/user/add-course" className="themeBtn"><i className="material-icons">add</i>Add New</Link> */}
            </div>
          </div>
        </div>

        <div className="listingMain">
          <Box sx={{ borderBottom: 1, borderColor: "#0057FF" }}>
            <Tabs
              value={value}
              onChange={handleChange}
              aria-label="basic tabs example"
            >
              <Tab label="Upcoming Events" {...a11yProps(0)} />
              <Tab label="Past events" {...a11yProps(1)} />
            </Tabs>
          </Box>
          <CustomTabPanel value={value} index={0}>
            {state.loading && <LoadingScreen />}

            <Grid container spacing={2}>
              {!state.loading &&
                state.listingData &&
                state.listingData.length > 0 &&
                state.listingData.map((item, index) => (
                  <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
                    <Box
                      className="event_card"
                      onClick={() =>
                        navigator(`/user/event-details?id=${item?.id}`, {
                          state: { event: item },
                        })
                      }
                      style={{ cursor: "pointer" }}
                    >
                      <div className="event_card_head">
                        <div className="img_block">
                          <img
                            src={`${process.env.REACT_APP_S3_URL}${item?.logo}`}
                            alt=""
                          />
                        </div>
                        <Typography color={"#fff"} fontWeight={500}>
                          {item?.eventName}
                        </Typography>
                      </div>
                      <div className="event_card_body">
                        <ul>
                          <li>
                            <img src="/images/pin-map.svg" alt="" />{" "}
                            {item?.eventAddress}
                          </li>
                          <li>
                            <img src="/images/clock.svg" alt="" />{" "}
                            {moment(item?.eventDate).format(
                              "MMMM Do YYYY, h:mm:ss a"
                            )}
                          </li>
                        </ul>
                      </div>
                    </Box>
                  </Grid>
                ))}
              {!state.loading &&
                state.listingData &&
                state.listingData.length === 0 && (
                  <Grid item xs={12}>
                    <Typography color={"#fff"} textAlign={"center"}>
                      No Record found!
                    </Typography>
                  </Grid>
                )}
            </Grid>
          </CustomTabPanel>
          <CustomTabPanel value={value} index={1}>
            {state.loading && <LoadingScreen />}

            <Grid container spacing={2}>
              {!state.loading &&
                state.listingData &&
                state.listingData.length > 0 &&
                state.listingData.map((item, index) => (
                  <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
                    <Box
                      className="event_card"
                      onClick={() =>
                        navigator(`/user/event-details?id=${item?.id}`, {
                          state: { event: item },
                        })
                      }
                      style={{ cursor: "pointer" }}
                    >
                      <div className="event_card_head">
                        <div className="img_block">
                          <img
                            src={`${process.env.REACT_APP_S3_URL}${item?.logo}`}
                            alt=""
                          />
                        </div>
                        <Typography color={"#fff"} fontWeight={500}>
                          {item?.eventName}
                        </Typography>
                      </div>
                      <div className="event_card_body">
                        <ul>
                          <li>
                            <img src="/images/pin-map.svg" alt="" />{" "}
                            {item?.eventAddress}
                          </li>
                          <li>
                            <img src="/images/clock.svg" alt="" />{" "}
                            {moment(item?.eventDate).format(
                              "MMMM Do YYYY, h:mm:ss a"
                            )}
                          </li>
                        </ul>
                      </div>
                    </Box>
                  </Grid>
                ))}
            </Grid>
          </CustomTabPanel>
        </div>
      </div>
    </>
  );
}
